/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1DocumentCourseCourseid200,
  GetApiV1DocumentCourseCourseid401,
  GetApiV1DocumentCourseCourseid404,
  GetApiV1DocumentCourseCourseid500,
  GetApiV1DocumentCourseCourseidPathParams,
  GetApiV1DocumentCourseCourseidQueryResponse,
} from "../../types/documentCourseController/GetApiV1DocumentCourseCourseid.ts";
import { courseManagementRepositoryResponseSchema } from "../courseManagementRepositoryResponseSchema.ts";

export const getApiV1DocumentCourseCourseidPathParamsSchema = z.object({
  courseId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1DocumentCourseCourseidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1DocumentCourseCourseid200Schema = z.lazy(
  () => courseManagementRepositoryResponseSchema,
) as unknown as ToZod<GetApiV1DocumentCourseCourseid200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1DocumentCourseCourseid401Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseCourseid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1DocumentCourseCourseid404Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseCourseid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1DocumentCourseCourseid500Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseCourseid500>;

export const getApiV1DocumentCourseCourseidQueryResponseSchema = z.lazy(
  () => getApiV1DocumentCourseCourseid200Schema,
) as unknown as ToZod<GetApiV1DocumentCourseCourseidQueryResponse>;
